import { useMutation } from '@tanstack/react-query';
import { getAuthModule } from '../install';
export function useChangePassword() {
    return useMutation({
        mutationFn: (input) => getAuthModule().actions.changePassword(input),
    });
}
